import React from 'react'
import { NextPage } from 'next'
import FilteredProductsList from 'components/filteredProductsList'
import { createClient } from 'prismicConfiguration'
import FilteredProductList from 'interfaces/prismic/filteredProductList'

interface Props {
	page: FilteredProductList | null
}

const Vorur: NextPage<Props> = ({ page }) => {
	return <FilteredProductsList page={page} />
}

Vorur.getInitialProps = async () => {
	try {
		const client = createClient()
		const page = await client.getSingle<FilteredProductList>('product_list', {})
		return { page }
	} catch (error) {
		return { page: null }
	}
}

export default Vorur
